module.exports = __webpack_public_path__ + "img/symbol_0.8d486475.png";